import React, { useEffect, useState } from "react";
import HomePage from "../../../../entities/DashboardPage/HRModule/HomePage";
import AuthService from "../../../../api/AuthService";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { hrModule } from "../../../../constants/pathFile";

const Home = () => {

  const [loading,setLoading] = useState(false);
  const [payrollStats, setPayrollStats] = useState(null);
  const [allStats, setAllStats] = useState(null);
  const [permission, setPermission] = useState(() => {
    try {
      const stored = localStorage.getItem("permission");
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  });
  const navigate = useNavigate();
  const location = useLocation();
  const role = localStorage.getItem("role") || "";
  const isEmployee = role === "Employee";
  const hasDashboardEdit = permission?.employee?.isEdit === true;
  const canShowDashboard = !isEmployee || hasDashboardEdit;
  const attendanceOnly = isEmployee && hasDashboardEdit;

  useEffect(() => {
    const handlePermissionUpdate = () => {
      try {
        const latest = localStorage.getItem("permission");
        setPermission(latest ? JSON.parse(latest) : null);
      } catch (error) {
        setPermission(null);
      }
    };

    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => window.removeEventListener("permissionUpdated", handlePermissionUpdate);
  }, []);

  const findFallbackPath = () => {
    const modules = hrModule?.[0]?.innerModule || [];
    const keyAlias = { commisson: "commission", travelAllowances: "travelAllowance" };

    const firstAllowed = modules.find((item) => {
      if (!item?.permission) return false;
      const permKey = keyAlias[item.permission] || item.permission;
      const access = permission?.[permKey];
      return access?.isView || access?.isEdit;
    });

    return firstAllowed ? `/dashboard/${firstAllowed.to}` : null;
  };

  useEffect(() => {
    if(role === "Admin"){
      getProfile();
    }
    if (canShowDashboard || !isEmployee) {
      fetchPayrollStats();
      fetchAllStats();
    }
    
  },[canShowDashboard, isEmployee]);
  const getProfile =  async(  ) =>{
    setLoading(true);

    try {
      const result = await AuthService.getProfile();
      if (result?.success) {
        setLoading(false);
      } else {
        navigate("/");
        localStorage.removeItem("accessToken","id","role",);
        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
    }
  };

  const fetchPayrollStats = async () => {
    try {
      const result = await AuthService.getPayrollStats();
      setPayrollStats(result?.data || result);
    } catch (error) {
      console.error("Error fetching payroll stats", error);
    }
  };

  const fetchAllStats = async () => {
    try {
      const result = await AuthService.getAllStats();
      setAllStats(result?.data || result);
    } catch (error) {
      console.error("Error fetching all stats", error);
    }
  };
  // Block dashboard view for employees without dashboard edit permission
  if (isEmployee && !hasDashboardEdit) {
    const fallbackPath = findFallbackPath() || "/dashboard/attendance";
    return <Navigate to={fallbackPath} replace />;
  }

  return (
    <HomePage
      loading={loading}
      payrollStats={payrollStats?.data?.payrollStats || payrollStats?.payrollStats || payrollStats}
      allStats={allStats?.data || allStats}
      attendanceOnly={attendanceOnly}
    />
  )

}

export default Home;
